<div style="height: 30px">
	<label>{{label}}</label> <span *ngIf="imageSrc" style="margin-left: 130px">
					<mat-icon class="icon-display" (click)="openDialog()" title="View">open_in_new</mat-icon>
					<mat-icon class="icon-display" title="Remove" (click)="imageSrc=null; fileInput.value=null;clearTarget()">delete</mat-icon>
				</span>
</div>

<div class="dropzone" #dropZone (dragover)="onDragOver($event)" (drop)="onDropSuccess($event)"
     (click)="fileInput.click()">
	<input type="file" #fileInput (change)="onChange($event)" accept="image/png, image/jpeg"
	       style="display: none;"/>
	<div class="drop-zone" #dropZone (dragover)="dropZone.style.border='2px solid green'"
	     (dragleave)="dropZone.style.border='2px dashed lightgray'"
	     (drop)="dropZone.style.border='2px dashed lightgray'">
		<label *ngIf="!imageSrc">Drag and drop your image here or click to browse</label>
		<img *ngIf="imageSrc" width="220" [src]="imageSrc" alt="Uploaded image preview" class="image-preview"/>
	</div>
</div>
